import Vuex from 'vuex';
import user from './user.store';
// eslint-disable-next-line import/no-cycle
import menu from './menu.store';
import common from './common.store';

export default new Vuex.Store({
  modules: { user, menu, common },
});
